import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Credits } from '@App/app/entities/admin-panel/credits.model';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyComponent {
  constructor() {}

  @Input()
  logo: string;
  @Input()
  isCompanyMenuAvailable: boolean;
  @Input()
  credits: Credits | null;

  @Output()
  companyMenuToggle = new EventEmitter<boolean>();

  @Output()
  creditsRequestDropdownToggle = new EventEmitter<boolean>();

  toggleMenu() {
    this.companyMenuToggle.emit(true);
  }

  toggleCreditsRequestDropdown() {
    this.creditsRequestDropdownToggle.emit(true);
  }
}
